import { useEffect, useMemo } from 'react';
import setupIndexedDB, { useIndexedDBStore } from 'use-indexeddb';

export const TB_BOOKMARK = 'bookmark';
export const TB_SETTING = 'setting';

// Database Configuration
const idbConfig = {
  databaseName: 'weatheri-db',
  version: 2,
  stores: [
    {
      name: TB_BOOKMARK,
      id: { keyPath: 'code', autoIncrement: false },
      indices: [
        { name: 'area1', keyPath: 'lat' },
        { name: 'area2', keyPath: 'lat' },
        { name: 'area3', keyPath: 'lat' },
        { name: 'lat', keyPath: 'lat' },
        { name: 'lng', keyPath: 'lng' },
        { name: 'sortOrder', keyPath: 'sortOrder' },
      ],
    },
    {
      name: TB_SETTING,
      id: { keyPath: 'type', autoIncrement: false },
      indices: [{ name: 'value', keyPath: 'value' }],
    },
  ],
};

export function useIndexedDB(table) {
  const { getAll, add, update, deleteByID, getByID } = useIndexedDBStore(table);

  function setup() {
    setupIndexedDB(idbConfig).catch((e) => console.error('error / unsupported', e));
  }

  async function getAllRows(orderBy) {
    try {
      const data = await getAll();

      if (orderBy) {
        orderBy(data);
      }

      return data;
    } catch (e) {
      console.log(e);
    }
  }

  async function getById(id) {
    try {
      const data = await getByID(id);

      return data;
    } catch (e) {
      console.log(e);
    }
  }

  async function checkExists(id) {
    try {
      await getByID(id);

      return true;
    } catch (e) {
      console.log(e);

      return false;
    }
  }

  async function countAllRows() {
    try {
      const data = await getAll();
      return data.length;
    } catch (e) {
      console.error(e);
    }
  }

  async function addRow(data) {
    try {
      await add(data);
    } catch (e) {
      console.error(e);
    }
  }

  async function updateRow(data) {
    try {
      await update(data);
    } catch (e) {
      console.error(e);
    }
  }

  async function updateRows(data) {
    try {
      for (const row of data) {
        await updateRow(row);
      }
    } catch (e) {
      console.error(e);
    }
  }

  async function deleteRow(id) {
    try {
      await deleteByID(id);
    } catch (e) {
      console.error(e);
    }
  }

  useEffect(() => {
    setup();
  }, []);

  return useMemo(
    () => ({
      getAllRows,
      getById,
      checkExists,
      countAllRows,
      addRow,
      updateRow,
      updateRows,
      deleteRow,
    }),
    [],
  );
}

export default useIndexedDB;
